define("shared/components/shared/expandable-radio-card-group", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <fieldset
    data-test-id="expandable-radio-card-group"
    name={{@name}}
    role="radiogroup"
    {{did-insert this.addEventListeners}}
    ...attributes
  >
    {{yield}}
  </fieldset>
  */
  {
    "id": "3a6PjoeB",
    "block": "[[[11,\"fieldset\"],[24,\"data-test-id\",\"expandable-radio-card-group\"],[16,3,[30,1]],[24,\"role\",\"radiogroup\"],[17,2],[4,[38,0],[[30,0,[\"addEventListeners\"]]],null],[12],[1,\"\\n  \"],[18,3,null],[1,\"\\n\"],[13]],[\"@name\",\"&attrs\",\"&default\"],false,[\"did-insert\",\"yield\"]]",
    "moduleName": "shared/components/shared/expandable-radio-card-group.hbs",
    "isStrictMode": false
  });

  let ExpandableRadioCardGroupComponent = (_class = class ExpandableRadioCardGroupComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "radioButtonGroup", null);
    }

    addEventListeners(radioButtonGroup) {
      this.radioButtonGroup = radioButtonGroup;
      radioButtonGroup.addEventListener('change', this.dispatchSynchronizeEvent);
    }

    dispatchSynchronizeEvent() {
      const inputs = document.getElementsByName(this.args.name);
      inputs.forEach(input => input.dispatchEvent(new Event('synchronize-radio-card-group')));
    }

    willDestroy() {
      super.willDestroy();
      this.radioButtonGroup?.removeEventListener('change', this.dispatchSynchronizeEvent);
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "addEventListeners", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addEventListeners"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dispatchSynchronizeEvent", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "dispatchSynchronizeEvent"), _class.prototype)), _class);
  _exports.default = ExpandableRadioCardGroupComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ExpandableRadioCardGroupComponent);
});